import { render, staticRenderFns } from "./PickupSpecificsModal.vue?vue&type=template&id=2cec08ac&scoped=true"
import script from "./PickupSpecificsModal.vue?vue&type=script&lang=ts"
export * from "./PickupSpecificsModal.vue?vue&type=script&lang=ts"
import style0 from "./PickupSpecificsModal.vue?vue&type=style&index=0&id=2cec08ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cec08ac",
  null
  
)

export default component.exports